import { Backdrop, Button, Card, CardContent, CircularProgress, Container, Divider, Grid, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Dialog, DialogContent, Box, Autocomplete, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Chart from "react-apexcharts";
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import Alert from 'src/components/Alert';
import moment from 'moment';
import Plot from "react-plotly.js";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from 'date-fns/locale/tr';
import WaveformPlayer from 'src/components/WaveformPlayer';


const localeMap = {
    tr: trLocale
};

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    table: {
        minWidth: 650,
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    title: (theme) => ({
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    }),
    media: (theme) => ({
        height: 210,
        padding: theme.spacing(6, 2)
    }),
    customCardContent: {
        '&.MuiCardContent-root:last-child': {
            paddingBottom: '0.65rem'
        }
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        paddingLeft: '16px',
        marginRight: '10px',
        borderRadius: 10
    }
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;





function SestekAiReport() {
    const params = useParams();
    const [search, setSearch] = React.useState('');
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [dataMain, setDataMain] = useState([]);
    const [mainSearchData, setMainSearchData] = useState([]);
    const [dataDetail, setDataDetail] = useState([]);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [DailerOpen, setDailerOpen] = React.useState(false);
    const [DailerData, setDailerData] = React.useState([]);
    const [DailerDataLink, setDailerDataLink] = React.useState('');
    const [audio, setAudio] = React.useState(new Audio(''));
    const [DailerOpenLink, setDailerOpenLink] = React.useState(false);
    const [UyariAciklama, setUyariAciklama] = useState("");
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [series, setSeries] = useState([]);
    const [options, setOptions] = useState(null);
    const [seriesDort, setSeriesDort] = useState([]);
    const [optionsDort, setOptionsDort] = useState(null);
    const [seriesBes, setSeriesBes] = useState([]);
    const [optionsBes, setOptionsBes] = useState(null);

    const [projectData, setProjectData] = useState([]);
    const [selectedProject, setSelectedProject] = useState({ "ID": 0, "ACIKLAMA": "All Type" });
    const [projectTypeLoading, setProjectTypeLoading] = useState(false);

    const waveformRef = useRef();

    const [sankeyData, setsankeyData] = useState({});

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [StartDate, setStartDate] = useState(
        new Date()
    );
    const [EndDate, setEndDate] = useState(
        new Date()
    );
    const formattedStartDate = moment(StartDate).format('YYYY-MM-DD')
    const formattedEndDate = moment(EndDate).format('YYYY-MM-DD')
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });


    React.useEffect(() => {
        getAiProjectTypes();
    }, [])

    const getAiProjectTypes = () => {
        setProjectTypeLoading(true);
        const isActiveTestConversation = "0"
        axios.get(`/GetAiProjectTypes/${isActiveTestConversation}`)
            .then((response) => {
                const data = response.data;
                setProjectData(data);
                setProjectTypeLoading(false);
            }).catch((err) => {
                setProjectTypeLoading(false);
            });
    }

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (dataMain?.UcuncuTable?.length > 0) {
            const sortedData = [...dataMain.UcuncuTable].sort((a, b) => b.YUZDE - a.YUZDE);
            const yuzdeler = sortedData.map(item => item.YUZDE);
            const etiketler = sortedData.map(item => `(${item.ADET}) ${item.RESULT}`);

            setSeries([{
                name: "Percentage",
                data: yuzdeler
            }]);

            setOptions({
                chart: {
                    type: 'bar',
                    height: isMobile ? 300 : 400,
                    width: '100%'

                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: isMobile ? '40%' : '60%',
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return `${val.toFixed(1)}%`;
                    },
                    style: {
                        fontSize: isMobile ? '10px' : '12px',
                        colors: ['#000']
                    }
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val.toFixed(2)}%`
                    }
                },
                xaxis: {
                    categories: etiketler,
                    labels: {
                        style: {
                            fontSize: isMobile ? '10px' : '12px'
                        },
                        formatter: (val) => `${val}%`
                    },
                    title: {
                        text: "Percentage"
                    }
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: isMobile ? '10px' : '12px',
                            fontWeight: 500
                        },
                        maxWidth: isMobile ? 150 : 400,
                    }
                },
                colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
                legend: {
                    show: false
                },
                responsive: [{
                    breakpoint: 768,
                    options: {
                        chart: {
                            height: 300
                        }
                    }
                }]
            });
        }

        if (dataMain?.DorduncuTable?.length > 0) {
            const sortedData = [...dataMain.DorduncuTable].sort((a, b) => b.YUZDE - a.YUZDE);
            const yuzdeler = sortedData.map(item => item.YUZDE);
            const etiketler = sortedData.map(item => `(${item.ADET}) ${item.RESULT}`);

            setSeriesDort([{
                name: "Percentage",
                data: yuzdeler
            }]);

            setOptionsDort({
                chart: {
                    type: 'bar',
                    height: isMobile ? 300 : 400,
                    width: '100%',
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: isMobile ? '40%' : '60%',
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return `${val.toFixed(1)}%`;
                    },
                    style: {
                        fontSize: isMobile ? '10px' : '12px',
                        colors: ['#000']
                    }
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val.toFixed(2)}%`
                    }
                },
                xaxis: {
                    categories: etiketler,
                    labels: {
                        style: {
                            fontSize: isMobile ? '10px' : '12px'
                        },
                        formatter: (val) => `${val}%`
                    },
                    title: {
                        text: "Percentage"
                    }
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: isMobile ? '10px' : '12px',
                            fontWeight: 500
                        },
                        maxWidth: isMobile ? 150 : 400,
                    }
                },
                colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
                legend: {
                    show: false
                },
                responsive: [{
                    breakpoint: 768,
                    options: {
                        chart: {
                            height: 300
                        }
                    }
                }]
            });
        }
        if (dataMain?.BesinciTable?.length > 0) {
            const row = dataMain.BesinciTable[0];
            const randevuAlinan = row.RANDEVU_ALINAN;
            const randevuAlinmayan = row.RANDEVU_ALINMAYAN;
            const toplam = randevuAlinan + randevuAlinmayan;

            const seriesData = [
                (randevuAlinan / toplam) * 100,
                (randevuAlinmayan / toplam) * 100,
            ];

            const adetler = [randevuAlinan, randevuAlinmayan];
            const labels = [
                `Appointment Taken<br/>`,
                `Appointment Not Taken<br/>`,
            ];

            setSeriesBes(seriesData);

            setOptionsBes({
                chart: {
                    type: "pie",
                },
                labels: labels,
                plotOptions: {
                    pie: {
                        dataLabels: {
                            offset: -10, // yazıyı merkeze çeker
                            minAngleToShowLabel: 10, // çok küçük dilimde yazı göstermeme
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    dropShadow: { enabled: false },
                    style: {
                        fontSize: isMobile ? "12px" : "16px", // biraz küçült
                        colors: ["#000"],
                        whiteSpace: 'pre-line',
                    },
                    formatter: function (val, opts) {
                        const Deger = opts.seriesIndex === 0 ? "Appointment Taken" : "Appointment Not Taken";
                        const adet = adetler[opts.seriesIndex];
                        return `${Deger}\n${val.toFixed(1)}% (${adet})`; // \n ile alt satır
                    },
                    textAnchor: 'middle',
                    offsetY: 0,
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function (val, opts) {
                            const adet = adetler[opts.seriesIndex];
                            return `${val.toFixed(2)}% - ${adet} units`;
                        },
                    },
                },
                colors: ["#00E396", "#FF4560"],
                legend: { show: false },
            });
        }


    }, [dataMain]);





    const getMainData = () => {
        setDataMain([]);
        setMainSearchData([]);
        setPage(0);
        setRowsPerPage(20);
        setLoading(true);

        var selectedProjectId = selectedProject.ID
        axios.get('GetSestekAiMainReport/' + formattedStartDate + '/' + formattedEndDate + '/' + selectedProjectId)
            .then((response) => {
                setDataMain(response.data);
                setMainSearchData(response.data);

                const rawData = response.data.AltinciTable;
                const labels = Array.from(new Set(rawData.flatMap(d => [d.from, d.to])));
                const nodeValues = labels.map(label => {
                    const incoming = rawData
                        .filter(d => d.to === label)
                        .reduce((sum, d) => sum + d.value, 0);
                    return incoming;
                });
                const yuzdeValues = labels.map(label => {
                    const found = rawData.find(d => d.to === label);
                    return found ? found.YUZDE : 0;
                });
                const sinks = labels.filter(l => !rawData.some(d => d.from === l));




                const positions = labels.map((label, i) => {
                    const found = rawData.find(d => d.to === label);
                    // yPositions varsa onu kullan, yoksa otomatik sırala (üstten alta)
                    if (found && found.yPositions !== undefined && found.yPositions !== null) {
                        return found.yPositions;
                    }
                    // yPositions yoksa index’e göre üstten alta sırala
                    return i;
                });

                const minPos = Math.min(...positions);
                const maxPos = Math.max(...positions);
                const range = maxPos - minPos || 1;

                const nodeColors = positions.map(pos => {
                    const normalized = (pos - minPos) / range; // 0 = en üst, 1 = en alt
                    const hue = 120 - (120 * normalized);     // 120 = yeşil, 0 = kırmızı
                    return `hsl(${hue}, 80%, 55%)`;
                });
                // BİTİŞ – Yeni renk kodu burada biter





                function wrapLabel(label, value, maxChars = 40, yuzde) {
                    const words = label.split(' ');
                    let lines = [], current = '';

                    words.forEach(word => {
                        if ((current + ' ' + word).trim().length > maxChars) {
                            lines.push(current.trim());
                            current = word;
                        } else {
                            current += ' ' + word;
                        }
                    });

                    if (current) lines.push(current.trim());

                    if (value == 0) {
                        lines.push(``);
                    } else {
                        lines.push(`(${value}) ${yuzde}%`);
                    }

                    return lines.join('<br>');
                }

                const wrappedLabels = labels.map((l, i) =>
                    wrapLabel(l, nodeValues[i], 40, yuzdeValues[i])
                );

                const nodeX = labels.map(label => {
                    const found = rawData.find(d => d.to === label);
                    return found?.xPositions ?? 0;
                });

                const nodeY = labels.map(label => {
                    const found = rawData.find(d => d.to === label);
                    return found?.yPositions ?? 0;
                });

                const links = rawData.map(d => ({
                    source: labels.indexOf(d.from),
                    target: labels.indexOf(d.to),
                    value: d.value,
                    color: nodeColors[labels.indexOf(d.to)],
                    hovertemplate:
                        `${wrapLabel(d.from, d.value)} → ${wrapLabel(d.to, d.value)}` +
                        `<br>Adet: ${d.value}<extra></extra>`
                }));
                setsankeyData({
                    type: "sankey",
                    orientation: "h",
                    arrangement: "snap",
                    node: {
                        pad: 40,
                        thickness: 20,
                        line: { color: "black", width: 0.5 },
                        label: wrappedLabels,
                        color: nodeColors,
                        x: nodeX,
                        y: nodeY
                    },
                    link: {
                        source: links.map(l => l.source),
                        target: links.map(l => l.target),
                        value: links.map(l => l.value),
                        color: links.map(l => l.color),
                        hovertemplate: links.map(l => l.hovertemplate)
                    }
                });

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }

    const getDetailData = (Id) => {
        setDataDetail([]);
        setLoading(true);
        axios.get('GetSestekAiDetail/' + Id)
            .then((response) => {
                setDataDetail(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }


    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };



    const handleSearch = async (event) => {


        const newString = event?.target.value;
        setSearch(newString);
        if (newString) {
            const lowercasedNewString = newString.toLowerCase('tr-TR');
            const filteredData = mainSearchData.filter(item => {
                const concatenatedStr = `${item.ConversaitonID}
                ${item.CallerPhoneNumber}
                ${item.CallEndStatus}
                ${item.LiveAgentTransferReason}
                ${item.ContactPhoneNumber}
                ${item.CaseID}
                ${item.ErrorLog}
                ${item.Result}
                ${item.Result_explanation}
                ${item.Ended_Stage}
                ${item.Failure_Point}`;
                const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
                return lowercasedConcatenatedStr.includes(lowercasedNewString);
            });
            setDataMain(filteredData);
        } else {
            setDataMain(mainSearchData);
        }
    };



    const GetDailerLink = () => {
        var CallId = selectedRowId;
        setLoading(true);
        setDailerOpen(true);
        axios.get('/GetDailerDataLink/' + CallId).then((response) => {
            const PaperCC = response.data;
            setDailerDataLink(PaperCC);
            setAudio(new Audio(PaperCC));
            setDailerOpenLink(true);
            setLoading(false);
        }).catch(error => {
            setUyariTip("error");
            setUyariAciklama("You do not have permission!...");
            setUyari(true);
            setLoading(false);
        });
    }

    const handleCloseDailerLink = () => {
        waveformRef.current?.stop();
        setDailerOpenLink(false);
    };



    const toggleExpanded = (id) => {
        setExpandedRowId(prev => prev === id ? null : id);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };



    return (
        <Page sx={styles.root}>
            <Backdrop sx={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container maxWidth={false}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>

                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 2
                                }}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={localeMap['tr']}
                                >
                                    <DatePicker
                                        label={'Start Date'}
                                        format={'dd.MM.yyyy'}
                                        value={StartDate}
                                        onChange={date => {
                                            setStartDate(date);
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 2
                                }}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={localeMap['tr']}
                                >
                                    <DatePicker
                                        label={'End Date'}
                                        format={'dd.MM.yyyy'}
                                        value={EndDate}
                                        onChange={date => {
                                            setEndDate(date);
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    options={projectData}
                                    getOptionLabel={(option) => option.ACIKLAMA || ""}
                                    value={selectedProject || ''}
                                    size="small"
                                    onChange={(event, newValue) => {
                                        setSelectedProject(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Project Type"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {projectTypeLoading ? (
                                                            <CircularProgress color="primary" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                    sx={{
                                        "& .MuiAutocomplete-endAdornment": {
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 3
                                }}>
                                <Stack direction="row" spacing={1}>
                                    <Button
                                        style={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            getMainData();
                                        }}
                                    >
                                        Search
                                        <SearchIcon style={{ marginLeft: '5px' }} />
                                    </Button>

                                </Stack>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 2,
                                    sm: 2,
                                    lg: 2
                                }}>

                            </Grid>



                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <TableContainer style={{ overflowY: 'auto' }}>
                                    <Table stickyHeader aria-label="sticky table" >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Project-Date Range</TableCell>
                                                <TableCell>Successful Call Count</TableCell>
                                                <TableCell>Total Call Count</TableCell>
                                                <TableCell>% Percentage</TableCell>
                                                <TableCell>Average Duration</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dataMain?.IlkTable?.map((row, index) => {
                                                const isLast = index === dataMain.IlkTable.length - 1;

                                                return (
                                                    <TableRow
                                                        key={row.TARIH}
                                                        onClick={() => {
                                                            setSelectedRowId(row.TARIH);
                                                        }}
                                                        style={{
                                                            backgroundColor:
                                                                row.ConversaitonID === selectedRowId ? "#e0f7fa" : "transparent",
                                                            cursor: "pointer"
                                                        }}
                                                    >
                                                        <TableCell style={{ fontWeight: isLast ? "bold" : "normal" }}>
                                                            {row.TARIH}
                                                        </TableCell>
                                                        <TableCell style={{ fontWeight: isLast ? "bold" : "normal" }}>
                                                            {row.RANDEVU_ALINAN_CAGRI_SAYISI}
                                                        </TableCell>
                                                        <TableCell style={{ fontWeight: isLast ? "bold" : "normal" }}>
                                                            {row.TOPLAM_CAGRI_SAYISI}
                                                        </TableCell>
                                                        <TableCell style={{ fontWeight: isLast ? "bold" : "normal" }}>
                                                            % {row.YUZDE}
                                                        </TableCell>
                                                        <TableCell style={{ fontWeight: isLast ? "bold" : "normal" }}>
                                                            {row.ORTALAMA_SURE}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>

                            <Divider />
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 6
                                }}>
                                <h5 style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>
                                    Result Explanations
                                </h5>
                                {
                                    options && series.length > 0 ? (
                                        <Chart options={options} series={series} type="bar" />
                                    ) : (
                                        <p>Loading chart...</p>
                                    )}

                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 6
                                }}>
                                <h5 style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>
                                    Live Agent Transfer Reasons
                                </h5>
                                <Divider />
                                {
                                    optionsDort && seriesDort.length > 0 ? (
                                        <Chart options={optionsDort} series={seriesDort} type="bar" />
                                    ) : (
                                        <p>Loading chart...</p>
                                    )
                                }
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <Divider />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <Box sx={{ width: "100%", height: { xs: "400px", sm: "600px", lg: "700px" } }}>
                                    <Plot
                                        data={[sankeyData]}
                                        layout={{
                                            title: "Sankey Diagram",
                                            font: { size: 16, color: "black" },
                                            paper_bgcolor: "rgba(0,0,0,0)",
                                            plot_bgcolor: "rgba(0,0,0,0)",
                                            autosize: true
                                        }}
                                        config={{
                                            responsive: true,
                                            toImageButtonOptions: {
                                                format: "png",
                                                filename: "sankey",
                                                height: 600,
                                                width: 1200,
                                                bgcolor: "rgba(0,0,0,0)" // 👈 BURASI
                                            }
                                        }}
                                        useResizeHandler={true}
                                        style={{ width: "100%", height: "100%" }}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
            <Dialog
                open={DailerOpenLink}
                maxWidth="lg"      // genişliği artırır
                fullWidth
                onClose={handleCloseDailerLink}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <div style={{ maxWidth: 1200, margin: "auto", padding: 20 }}>
                        <WaveformPlayer ref={waveformRef} audioUrl={DailerDataLink} />
                    </div>
                </DialogContent>
            </Dialog>

        </Page >
    );
}
export default SestekAiReport;